import React, { useState } from "react";

const GeneralActionDisplay = (props) => {

    const character = props.character;
    const abilityID = props.item.id;
    const pools = props.generalPools;
    const setPools = props.setGeneralPools;
    const isPowers = props.isPowers;

    const [isExpanded, setIsExpanded] = useState(false);

    const maxPoints = () => {
        return isPowers ? character.powers[abilityID] : character.generalAbilities[abilityID];
    }

    const currentPoints = () => {
        return abilityID in pools ? pools[abilityID] : maxPoints();
    }

    function updatePointMap(updatedCount) {
        const copyMap = structuredClone(pools);
        copyMap[abilityID] = updatedCount;
        setPools(copyMap);
    }

    function incrementCount() {
        const count = currentPoints();
        const updatedCount = count < maxPoints() ? count + 1 : count;
        updatePointMap(updatedCount);
    }

    function decrementCount() {
        const count = currentPoints();
        const updatedCount = Math.max(0, count - 1);
        updatePointMap(updatedCount);
    }

    // expand/collapse

    function toggleExpandDisplay() {
        setIsExpanded(!isExpanded);
    }

    function classNames(classes) {
        return Object.entries(classes)
            .filter(([key, value]) => value)
            .map(([key, value]) => key)
            .join(' ');
    }

    const expandClasses = {
        'App-action-expandicon': true,
        'expand-icon--selected': isExpanded
    };

    const expandClassNames = classNames(expandClasses);

    const labelClasses = {
        'App--action-label': true,
        'App--action-label-expand': isExpanded
    };

    const labelClassNames = classNames(labelClasses);

    const descriptionClasses = {
        'App--action-desc': true,
        'App--action-desc-expand': isExpanded
    };

    const descriptionClassNames = classNames(descriptionClasses);

    const titleClasses = {
        'App--action-title-label': true,
        'App--action-title-label-expand': isExpanded
    };

    const titleClassNames = classNames(titleClasses);

    return (
        <div className="App--general-action-row">
            <button type="button" onClick={toggleExpandDisplay}  className="App--general-action-button">
                <div id={"action-display-" + abilityID} className="App-action-expand-button">
                    <div className={expandClassNames}/>
                </div>
                <div className={labelClassNames}>
                    <div className={titleClassNames} >{props.item.name}</div>
                    <div className={descriptionClassNames}>
                            {props.item.description}
                        </div>
                </div>
            </button>
            <div className="App--general-action-points-box">
                <button type="button" className="App--general-action-points-adjust-button"
                    onClick={decrementCount}>
                    <div className="App--general-action-points-adjust-button-text">
                        <img alt="plus" src="./minus-button.png" width="40px" />
                        </div>
                    </button>
                <div className="App--general-action-points-text">
                    <div className="App--general-action-points-text-current">
                        {currentPoints()} 
                    </div>
                    <div className="App--general-action-points-text-max">
                        {"/"}
                        {maxPoints()}
                    </div>
                </div>
                <button type="button" className="App--general-action-points-adjust-button"
                    onClick={incrementCount}>
                    <div className="App--general-action-points-adjust-button-text">
                        <img alt="plus" src="./plus-button.png" width="40px"/>
                    </div>
                    </button>
            </div>
        </div>
    );
};

export default GeneralActionDisplay;